import React from 'react';
import isNil from 'lodash/isNil';

let formRefID = 0;

class GetDemoForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formReady: false,
    };
    this.formEl = null;
    this.formID = formRefID++;
    this.loadHubScript = this.loadHubScript.bind(this);
    this.createHubspotForm = this.createHubspotForm.bind(this);
    this.checkFormState = this.checkFormState.bind(this);
  }

  render() {
    return (
      <div style={{ marginLeft: '-30%' }}>
        <div
          ref={(el) => (this.formEl = el)}
          id={`hubform-demo-${this.formID}`}
          style={{
            display: this.state.formReady ? 'block' : 'none',
            width: 450,
          }}
        ></div>
      </div>
    );
  }

  componentDidMount() {
    if (!window.hbspt) {
      this.loadHubScript();
    } else {
      this.createHubspotForm();
      this.checkFormState();
    }
  }

  createHubspotForm() {
    if (window.hbspt) {
      if (this.formEl === null) {
        return;
      }

      let options = {
        region: 'na1',
        portalId: '3222786',
        formId: 'a741f72a-9dda-4db6-bb21-c91164240cd8',
        target: `#${this.formEl.getAttribute(`id`)}`,
        onFormReady: ($form) => {},
        onFormSubmit: ($form) => {
          if (this.formEl) {
            const iframe = this.formEl.querySelector('.hs-form-iframe');
            if (iframe) {
              if (this.props.customer_identifier) {
                let custIdentifierField = iframe.contentWindow.document.querySelector(
                  'input[name="amz_marketplace_cust_id"]',
                );
                if (!isNil(custIdentifierField)) {
                  custIdentifierField.value = this.props.customer_identifier;
                }
              }

              if (this.props.product_code) {
                let productCodeField = iframe.contentWindow.document.querySelector(
                  'input[name="amz_marketplace_product_code"]',
                );
                if (!isNil(productCodeField)) {
                  productCodeField.value = this.props.product_code;
                }
              }
            }
          }
        },
      };
      window.jQuery =
        window.jQuery ||
        (() => ({
          change: () => {},
          trigger: () => {},
        }));

      window.hbspt.forms.create(options);
      return true;
    } else {
      setTimeout(this.createHubspotForm, 1);
    }
  }

  checkFormState() {
    if (this.formEl === null) {
      return;
    }

    let form = this.formEl.querySelector(`iframe`);
    if (form) {
      this.setState({ formReady: true });
    } else {
      setTimeout(this.checkFormState, 1);
    }
  }

  loadHubScript() {
    let script = document.createElement('script');
    script.defer = true;
    script.src = 'https://js.hsforms.net/forms/v2.js';
    script.onload = () => {
      this.createHubspotForm();
      this.checkFormState();
    };
    document.head.appendChild(script);
  }
}

GetDemoForm.defaultProps = {
  mktplace_token: null,
  customer_identifier: null,
  product_code: null,
};
export default GetDemoForm;
